var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlignBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 28H24C24.5302 27.9994 25.0386 27.7885 25.4135 27.4135C25.7885 27.0386 25.9994 26.5302 26 26V10C25.9994 9.46975 25.7885 8.9614 25.4135 8.58646C25.0386 8.21151 24.5302 8.00061 24 8H19C18.4698 8.00061 17.9614 8.21151 17.5865 8.58646C17.2115 8.9614 17.0006 9.46975 17 10V26C17.0006 26.5302 17.2115 27.0386 17.5865 27.4135C17.9614 27.7885 18.4698 27.9994 19 28ZM8 28H13C13.5302 27.9994 14.0386 27.7885 14.4135 27.4135C14.7885 27.0386 14.9994 26.5302 15 26V5C14.9994 4.46975 14.7885 3.9614 14.4135 3.58646C14.0386 3.21151 13.5302 3.00061 13 3H8C7.46975 3.00061 6.9614 3.21151 6.58646 3.58646C6.21151 3.9614 6.00061 4.46975 6 5V26C6.00061 26.5302 6.21151 27.0386 6.58646 27.4135C6.9614 27.7885 7.46975 27.9994 8 28Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignBottom);
export default __webpack_public_path__ + "static/media/AlignBottom.2c8d104d.svg";
export { ForwardRef as ReactComponent };